import { type FC } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { useRootSelector } from "@ds/hooks";

import { CONTENT_PLAYLISTS_SEGMENT } from "@ds/constants/router";

import { PlaylistsRouter } from "./playlists/playlists-router";
import { selectCurrentView } from "./redux/selectors";

const ContentRouteSwitch = () => {
  const currentView = useRootSelector(selectCurrentView);
  if (currentView) {
    return <Navigate to={currentView} replace />;
  }

  return <Navigate to={CONTENT_PLAYLISTS_SEGMENT} replace />;
};

export const ContentRouter: FC = () => (
  <Routes>
    <Route path="*" element={<ContentRouteSwitch />} />
    <Route path={`${CONTENT_PLAYLISTS_SEGMENT}/*`} element={<PlaylistsRouter />} />
  </Routes>
);
